import React from "react"
import { StaticQuery, graphql } from "gatsby"

import Card from "@components/card"
import { HeadingThree } from "@components/type"

const GibsonCard = ({ colour }) => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { eq: "home/gary-gibson.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 475) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Card image={data.file.childImageSharp.fluid}>
        <HeadingThree colour={colour}>Gary Gibson</HeadingThree>
        <p>
          Under Gary’s leadership the bookstore raised over $23,000 in 2018!
        </p>
      </Card>
    )}
  />
)

export default GibsonCard
